import { GETTERS } from '../constants';

const getters = {
    getShipmentDirections(state) {
        return state.shipmentDirections;
    },

    getCompanyAccounts(state) {
        return state.accounts;
    },
    
    getCountries(state) {
        return state.countries
    },

    getSearchOptions(state) {
        return state.searchOptions;
    },
    getDeliveryStatuses(state) {
        return state.deliveryStatuses;
    },
    getDeliverStatusesWithoutUndelivered(state) {
        const deliveryStatusCopy = [...state.deliveryStatuses];
        const index = deliveryStatusCopy.indexOf('UnDelivered');

        if (index > 0) {
            deliveryStatusCopy.splice(index, 1);
        }

        return deliveryStatusCopy;
    },
    getSalesProducts(state) {
        const products = state.salesProducts.filter((x) => !x.deleted )
        
        const spinProducts = products.filter((x) =>
            x.displayName.toLowerCase().includes('express')
        );
        const salesProductsCopy = products.filter(
            (x) => !x.displayName.toLowerCase().includes('express')
        );

        const spinProductsIds = spinProducts.map((x) => x.id);

        // No id set for custom sales product with underlying sales products.
        // Used to select multiple sales products by selecting one.
        salesProductsCopy.unshift({
            displayName: 'Link Express',
            internalName: 'Link Express',
            shipmentSystem: 'YOYODenmark',
            id: Number.MAX_SAFE_INTEGER,
            underlyingSalesProducts: spinProductsIds
        });
        return salesProductsCopy;
    },
    getTransportCompanies(state) {
        return state.transportCompanies;
    },
    getSelectedRows(state) {
        return state.selectedRows;
    },
    getShipments(state) {
        return state.shipments;
    },
    [GETTERS.HISTORY.GET_FILTER]: (state) => {
        return state.filter;
    }
};

export default getters;
